import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import React from 'react';
import isEqual from 'lodash.isequal';
import cn from 'classnames';
import { CommonWrapper } from '@skbkontur/react-ui/internal/CommonWrapper';
import { Link } from '@skbkontur/react-ui/components/Link';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { EditIcon as Edit } from '@skbkontur/react-ui/internal/icons/16px';
import { LocaleContext } from '@skbkontur/react-ui/lib/locale';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { FiasLocaleHelper } from './locale';
import { FiasExtraFields, FiasFields, FiasDivision, FiasSchema, } from './types';
import { FiasModal } from './FiasModal';
import { FiasForm } from './Form/FiasForm';
import { FiasAPI } from './api/FiasAPI';
import { FiasAddress } from './models/FiasAddress';
import { FiasLogger } from './logger/FiasLogger';
import { jsStyles } from './Fias.styles';
import { defaultDivision, defaultSchema } from './constants/defaults';
function deepMerge(dst) {
    var src = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        src[_i - 1] = arguments[_i];
    }
    src.forEach(function (obj) {
        for (var k in obj) {
            if (dst[k] != null && typeof obj[k] === 'object') {
                dst[k] = deepMerge(dst[k], obj[k]);
            }
            else {
                dst[k] = obj[k];
            }
        }
    });
    return dst;
}
var Fias = /** @class */ (function (_super) {
    __extends(Fias, _super);
    function Fias(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            opened: false,
            address: new FiasAddress(),
            locale: FiasLocaleHelper.get(),
        };
        _this.form = null;
        _this.componentDidMount = function () {
            _this.updateLocale();
            _this.init();
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            if (!isEqual(prevProps.value, _this.props.value)) {
                _this.updateAddress();
            }
            if (!isEqual(prevState.locale, _this.locale)) {
                _this.updateLocale(_this.locale);
            }
        };
        _this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAddress()];
                    case 1:
                        address = _a.sent();
                        if (this.props.onInit) {
                            this.props.onInit(address.getValue(this.isFieldVisible(FiasExtraFields.postalcode)));
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateAddress = function () { return __awaiter(_this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FiasAddress.getAddress(this.api, this.props.value, this.fieldsSettings)];
                    case 1:
                        address = _a.sent();
                        this.setState({
                            address: address,
                        });
                        return [2 /*return*/, address];
                }
            });
        }); };
        _this.updateLocale = function (nextLocale) {
            if (nextLocale === void 0) { nextLocale = FiasLocaleHelper.get(); }
            _this.setState({ locale: nextLocale });
        };
        _this.handleOpen = function () {
            _this.setState({ opened: true });
        };
        _this.handleClose = function () {
            _this.setState({ opened: false });
            var onClose = _this.props.onClose;
            if (onClose) {
                onClose();
            }
        };
        _this.handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, address, division;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.form) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.form.submit()];
                    case 1:
                        _a = _b.sent(), address = _a.address, division = _a.division;
                        if (address.hasErrors && this.props.allowNotVerified === false) {
                            return [2 /*return*/];
                        }
                        this.handleChange(address, division);
                        _b.label = 2;
                    case 2:
                        this.handleClose();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleChange = function (address, division) {
            if (_this.props.onValueChange) {
                _this.props.onValueChange(address.getValue(_this.isFieldVisible(FiasExtraFields.postalcode), division));
            }
        };
        _this.refForm = function (element) {
            _this.form = element;
        };
        if (!props.baseUrl && !props.api) {
            FiasLogger.log(FiasLogger.warnings.baseUrlOrApiIsRequired);
        }
        return _this;
    }
    Fias_1 = Fias;
    Object.defineProperty(Fias.prototype, "division", {
        get: function () {
            var _a = this.props, division = _a.division, value = _a.value, api = _a.api;
            return division || (value === null || value === void 0 ? void 0 : value.division) || (api === null || api === void 0 ? void 0 : api.division) || defaultDivision;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Fias.prototype, "schema", {
        get: function () {
            var _a = this.props, schema = _a.schema, api = _a.api;
            return schema || (api === null || api === void 0 ? void 0 : api.schema) || defaultSchema;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Fias.prototype, "suggestUnknownParts", {
        get: function () {
            var _a = this.props, suggestUnknownParts = _a.suggestUnknownParts, api = _a.api;
            return suggestUnknownParts || (api === null || api === void 0 ? void 0 : api.suggestUnknownParts);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Fias.prototype, "suggestUnknownLevel", {
        get: function () {
            var _a = this.props, suggestUnknownLevel = _a.suggestUnknownLevel, api = _a.api;
            return suggestUnknownLevel || (api === null || api === void 0 ? void 0 : api.suggestUnknownLevel);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Fias.prototype, "fieldsSettings", {
        get: function () {
            var _a = this.props, userFieldsSettings = _a.fieldsSettings, countrySelector = _a.countrySelector;
            return Fias_1.getFieldsSettings({
                userFieldsSettings: userFieldsSettings,
                countrySelector: countrySelector,
                division: this.division,
                schema: this.schema,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Fias.prototype, "api", {
        get: function () {
            var _a = this.props, api = _a.api, baseUrl = _a.baseUrl, version = _a.version;
            return (api ||
                new FiasAPI({
                    baseUrl: baseUrl,
                    version: version,
                    division: this.division,
                    schema: this.schema,
                    suggestUnknownParts: this.suggestUnknownParts,
                    suggestUnknownLevel: this.suggestUnknownLevel,
                }));
        },
        enumerable: false,
        configurable: true
    });
    Fias.prototype.isFieldVisible = function (field) {
        return FiasAddress.isFieldVisible(field, this.fieldsSettings);
    };
    Fias.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContext.Consumer, null, function (theme) {
            _this.theme = getAddonsTheme(theme);
            return _this.renderMain();
        }));
    };
    Fias.prototype.open = function () {
        this.handleOpen();
    };
    Fias.prototype.close = function () {
        this.handleClose();
    };
    Fias.prototype.resetForm = function (value) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, userFieldsSettings, countrySelector, division, schema, address, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = this.props, userFieldsSettings = _b.fieldsSettings, countrySelector = _b.countrySelector;
                        division = (value === null || value === void 0 ? void 0 : value.division) || this.division;
                        schema = this.schema;
                        if (!value) return [3 /*break*/, 2];
                        return [4 /*yield*/, FiasAddress.getAddress(FiasAPI.createFromAPI(this.api, { division: division }), value, Fias_1.getFieldsSettings({ userFieldsSettings: userFieldsSettings, division: division, schema: schema, countrySelector: countrySelector }))];
                    case 1:
                        _c = _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _c = this.state.address;
                        _d.label = 3;
                    case 3:
                        address = _c;
                        (_a = this.form) === null || _a === void 0 ? void 0 : _a.reset({ address: address, division: division });
                        return [2 /*return*/];
                }
            });
        });
    };
    Fias.prototype.renderMain = function () {
        var _a;
        var _b = this.props, showAddressText = _b.showAddressText, label = _b.label, labelComponent = _b.labelComponent, icon = _b.icon, error = _b.error, warning = _b.warning, feedback = _b.feedback;
        var _c = this.state, opened = _c.opened, address = _c.address;
        var linkText = label || (address.isEmpty ? this.state.locale.addressFill : this.state.locale.addressEdit);
        var Component = labelComponent;
        var validation = (error || warning) && feedback ? (React.createElement("span", { className: cn((_a = {},
                _a[jsStyles.error(this.theme)] = Boolean(error),
                _a[jsStyles.warning(this.theme)] = Boolean(warning),
                _a)), "data-tid": "fias-validation" }, feedback)) : null;
        return (React.createElement(LocaleContext.Provider, { value: { locale: { Fias: this.state.locale } } },
            React.createElement(CommonWrapper, __assign({}, this.props),
                React.createElement("div", null,
                    showAddressText && (React.createElement("span", { "data-tid": "fias-fullText" }, address.getFullText(this.isFieldVisible(FiasExtraFields.postalcode)))),
                    !this.props.readonly && (React.createElement("div", null, Component ? (React.createElement(Component, { icon: icon, onClick: this.handleOpen, "data-tid": "fias-link" })) : (React.createElement(Link, { icon: icon, onClick: this.handleOpen, "data-tid": "fias-link" }, linkText)))),
                    validation,
                    opened && this.renderModal()))));
    };
    Fias.prototype.renderModal = function () {
        var Modal = this.props.modal || FiasModal;
        return (React.createElement(Modal, { onClose: this.handleClose, onSave: this.handleSave }, this.renderForm()));
    };
    Fias.prototype.renderForm = function () {
        var address = this.state.address;
        var _a = this.props, search = _a.search, limit = _a.limit, formValidation = _a.formValidation, countrySelector = _a.countrySelector, divisionSelector = _a.divisionSelector, allowArbitraryCountry = _a.allowArbitraryCountry, _b = _a.renderForm, renderForm = _b === void 0 ? function (form) { return form; } : _b, fieldsSettings = _a.fieldsSettings;
        return renderForm(React.createElement(FiasForm, { ref: this.refForm, address: address, api: this.api, search: search, limit: limit, validationLevel: formValidation, countrySelector: countrySelector, allowArbitraryCountry: allowArbitraryCountry, userFieldsSettings: fieldsSettings, divisionSelector: divisionSelector }));
    };
    var Fias_1;
    Fias.__KONTUR_REACT_UI__ = 'Fias';
    Fias.displayName = 'Fias';
    Fias.defaultProps = {
        showAddressText: true,
        error: false,
        warning: false,
        readonly: false,
        search: false,
        icon: React.createElement(Edit, null),
        allowNotVerified: true,
        fieldsSettings: {},
        countrySelector: false,
        allowArbitraryCountry: false,
        renderForm: function (form) { return form; },
    };
    Fias.getFieldsSettings = function (_a) {
        var _b;
        var userFieldsSettings = _a.userFieldsSettings, division = _a.division, schema = _a.schema, countrySelector = _a.countrySelector;
        // TODO: implement deepMerge with clone
        return deepMerge(Fias_1.getDefaultFieldsSettings({ division: division, schema: schema }), (_b = {},
            _b[FiasExtraFields.postalcode] = {
                visible: Boolean(countrySelector),
            },
            _b), userFieldsSettings);
    };
    Fias.getDefaultFieldsSettings = function (_a) {
        var _b = _a === void 0 ? { division: defaultDivision, schema: FiasSchema.Fias } : _a, division = _b.division, schema = _b.schema;
        return FiasAddress.ALL_FIELDS.reduce(function (settings, field) {
            var _a;
            return (__assign(__assign({}, settings), (_a = {}, _a[field] = {
                visible: Fias_1.getDefaultFieldVisibility(field, division, schema),
                validation: true,
            }, _a)));
        }, {});
    };
    Fias.getDefaultFieldVisibility = function (field, division, schema) {
        switch (field) {
            case FiasFields.district:
                return division === FiasDivision.Administrative;
            case FiasFields.municipaldistrict:
            case FiasFields.urbansettlement:
                return division === FiasDivision.Municipal;
            case FiasFields.garhouse:
                return schema === FiasSchema.Gar;
            case FiasFields.house:
                return schema === FiasSchema.Fias;
            default:
                return true;
        }
    };
    Fias = Fias_1 = __decorate([
        locale('Fias', FiasLocaleHelper)
    ], Fias);
    return Fias;
}(React.Component));
export { Fias };
